import React from 'react';

import moment from 'moment';
import 'moment/locale/es';

export const dateTimeFormat = (date) => {
    return moment(date).format('YYYY-MM-DD');
};

export const stationFormat = (station) =>{
    return `Boca ${station.global_code} - ${station.company.name} - ${station.address}`;
}


// WEBPACK FOOTER //
// ./src/utils/formatters.js